<page-heading
  [title]="isNew ? ('agents.openaiIntegrationForm.titleNew' | translate) : ('agents.openaiIntegrationForm.titleEdit' | translate)"
  [description]="
    isNew
      ? ('agents.openaiIntegrationForm.descriptionNew' | translate)
      : ('agents.openaiIntegrationForm.descriptionEdit' | translate)
  "
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

@if (loadingContent) {
<content-loading-list />
}

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-xs-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-xs-12 mb-3">
              <label class="form-label">{{ 'agents.openaiIntegrationForm.nameLabel' | translate }}</label>
              <input
                type="text"
                class="form-control"
                maxlength="255"
                formControlName="name"
                [placeholder]="'agents.openaiIntegrationForm.namePlaceholder' | translate"
                required
              />
              <field-error-component
                [field]="'name'"
                [label]="'agents.openaiIntegrationForm.nameErrorLabel' | translate"
                [formGroup]="formGroup"
              />
            </div>
            <div class="col-xs-12 mb-3">
              <div formGroupName="metadata" class="row">
                <div class="position-relative col-xs-12 mb-3">
                  <label class="form-label">{{ 'agents.openaiIntegrationForm.tokenLabel' | translate }}</label>
                  <input
                    [type]="hideAllPasswords ? 'password' : 'text'"
                    class="form-control"
                    maxlength="255"
                    formControlName="token"
                    placeholder="sk-..."
                    required
                  />

                  <field-error-component
                    [field]="'metadata.token'"
                    [label]="'agents.openaiIntegrationForm.tokenErrorLabel' | translate"
                    [formGroup]="formGroup"
                  />
                  <i
                    class="bi icon-eye"
                    [ngClass]="hideAllPasswords ? 'bi-eye-slash' : 'bi-eye'"
                    (click)="togglePasswordVisibility()"
                  ></i>
                </div>
                <div class="col-xs-12 mb-3">
                  <label class="form-label">{{ 'agents.openaiIntegrationForm.organizationLabel' | translate }}</label>
                  <input
                    type="text"
                    class="form-control"
                    maxlength="255"
                    formControlName="organization"
                    required
                  />
                  <field-error-component
                    [field]="'metadata.organization'"
                    [label]="'agents.openaiIntegrationForm.organizationErrorLabel' | translate"
                    [formGroup]="formGroup"
                  />
                </div>
                <div class="col-xs-12 mb-3">
                  <label class="form-label">{{ 'agents.openaiIntegrationForm.projectLabel' | translate }}</label>
                  <input
                    type="text"
                    class="form-control"
                    maxlength="255"
                    formControlName="project"
                    placeholder="proj-..."
                    required
                  />
                  <field-error-component
                    [field]="'metadata.project'"
                    [label]="'agents.openaiIntegrationForm.projectErrorLabel' | translate"
                    [formGroup]="formGroup"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="row">
  <div class="col-12 gap-2 d-flex justify-content-end pb-4">
    <button class="btn btn-outline-secondary" (click)="cancel()">
      {{ 'agents.openaiIntegrationForm.cancelButton' | translate }}
    </button>
    @if (!isNew) {
    <button class="btn btn-outline-secondary" (click)="goToAssistants()">
      {{ 'agents.openaiIntegrationForm.assistantsButton' | translate }}
    </button>
    }

    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="!formGroup.valid || loading"
      (click)="onSubmit()"
    >
      {{ !loading ? (isNew ? ('agents.openaiIntegrationForm.saveButton' | translate) : ('agents.openaiIntegrationForm.updateButton' | translate)) : "" }}
      @if (loading) {
      <mat-spinner [diameter]="15" [color]="'accent'" mode="indeterminate" />
      }
    </button>
  </div>
</div>
